import React from 'react';
import {
  List,
  ListItem,
  IconButton,
  Typography,
  Box,
  Chip,
  Paper,
  Grid,
  Button
} from '@mui/material';
import { Edit, Delete, OpenInNew, Schedule } from '@mui/icons-material';

const FlowList = ({ flows, onEdit, onDelete, onOpenFlow, onBackups }) => {
  const getNodeCount = (flow) => {
    return flow.nodes?.length || 0;
  };

  const getEdgeCount = (flow) => {
    return flow.edges?.length || 0;
  };

  const getLastModified = (flow) => {
    if (!flow.updatedAt) return 'Unknown';
    return new Date(flow.updatedAt).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <List>
      {flows.map((flow) => (
        <ListItem key={flow._id} component={Paper} sx={{ mb: 2, p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                gap={2}
                flexWrap="wrap"
              >
                <Box flex={1} minWidth={0}>
                  <Typography
                    variant="h6"
                    component="h3"
                    onClick={() => onOpenFlow(flow)}
                    sx={{
                      cursor: 'pointer',
                      textAlign: 'left',
                      wordBreak: 'break-word',
                      '&:hover': { color: 'primary.light' }
                    }}
                  >
                    {flow.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Last modified: {getLastModified(flow)}
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap={0.75}
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<OpenInNew />}
                    onClick={() => onOpenFlow(flow)}
                  >
                    Open
                  </Button>
                  <IconButton
                    color="secondary"
                    onClick={() => onBackups(flow)}
                    title="Backups"
                    size="small"
                  >
                    <Schedule />
                  </IconButton>
                  <IconButton
                    color="primary"
                    onClick={() => onEdit(flow)}
                    title="Edit"
                    size="small"
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => onDelete(flow._id)}
                    title="Delete"
                    size="small"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" gap={1} flexWrap="wrap">
                <Chip
                  label={`${getNodeCount(flow)} nodes`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
                <Chip
                  label={`${getEdgeCount(flow)} edges`}
                  size="small"
                  color="secondary"
                  variant="outlined"
                />
                {flow.nodes?.length > 0 && (
                  <Chip label="Has content" size="small" color="success" />
                )}
              </Box>
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
};

export default FlowList;
